import { Middleware } from 'redux'
import { Observer } from './_base/Observer'
import { getAPIURL } from './URLs.jsx'

// 1. Create type of object to pass to log event
interface LogInfo {
    EventName: string
    EventTimestamp?: Date
    Username?: string
    String1?: string
    String2?: string
    String3?: string
    Decimal1?: string
    Decimal2?: string
    Datetime1?: Date
    Datetime2?: Date
    MessageBody?: string
}

// 2. Create Observer object to accept input object
const logObserver = new Observer<LogInfo>()

// 5. Validate input data a fire subscribed-to events (fetchLog)
export const logEvent = (info: LogInfo) => {
    info.String1 = info.String1 || ''
    info.String2 = info.String2 || ''
    info.String3 = info.String3 || ''
    info.MessageBody = info.MessageBody || ''
    logObserver.fire(info)
}

// 3. Create function to post log
const fetchLog = async (info: LogInfo) => {
    const url = getAPIURL() + 'master/logEvent'
    // TODO save failed logs/batch logs
    try {
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            // assures that this stays alive if browser closes while this was in process of sending
            keepalive: true,
            credentials: 'include',
            body: JSON.stringify(info),
        })
    } catch {
        console.warn('failed to send log')
    }
}

// 4. Subscribe to fetchLog action
logObserver.subscribe(fetchLog)

const actionsToLog: Record<string, string> = {
    'order/sendQuote/fulfilled': 'Fast Quote Send Quote',
    'order/saveOrder/fulfilled': 'Fast Quote Save Order',
}
const logMiddleware = (): Middleware => (store) => (next) => (action) => {
    let eventName = actionsToLog[action.type as string]
    if (eventName) {
        logEvent({ EventName: eventName })
    }
    let result = next(action)
    return result
}

export { logMiddleware }
